import Head from 'next/head';
import { DefaultSeo } from 'next-seo';

export default function StructuredData() {
  return (
    <>
      <DefaultSeo
      // Define default SEO configuration here
      />
      <Head>
        <title>
          eighteen yards | contact us
        </title>
        <meta
          name="description"
          content="Contact eighteen yards today to discuss your sports digital marketing needs. Your trusted partner in performance-driven sports digital marketing."
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              "name": "eighteen yards | Contact Us",
              "description": "Contact eighteen yards today to discuss your sports digital marketing needs. Your trusted partner in performance-driven sports digital marketing.",
              "url": "https://eighteenyards.com/contact",
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": "https://eighteenyards.com/contact"
              },
              "breadcrumb": {
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://eighteenyards.com"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Contact",
                    "item": "https://eighteenyards.com/contact"
                  }
                ]
              },
              "headline": "Contact Our Team",
              "publisher": {
                "@type": "Organization",
                "name": "eighteen yards",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://example.com/logo.png",
                  "width": 600,
                  "height": 60
                }
              },
              "image": {
                "@type": "ImageObject",
                "url": "https://example.com/image.jpg",
                "width": 1200,
                "height": 630
              }

            }),
          }}
        />
      </Head>
    </>
  )
}
